import React from 'react';
import styled from 'styled-components';
import {fonts, mediaQueries} from '../shared/config'
import Tabs from 'react-bootstrap/Tabs'
import Tab from 'react-bootstrap/Tab'

import 'bootstrap/dist/css/bootstrap.min.css';


const TextBox = styled.div`
    padding: 10px 10px;
    font-family: 'Cardo', serif;    
    /* display: flex;  
    justify-content: center;
    flex-direction: column;
    align-items: center; */
    @media (max-width: 700px){
    padding: 10px 15px;
    }
`

const Title = styled.div`
    font-size: 50px;
    font-family: 'Staatliches', cursive;
    @media (max-width: 700px){
    font-size: 25px;
    margin-top: 10px;
    }
`

const Image = styled.img`
    /* display: flex;  
    justify-content: center;
    flex-direction: column;
    align-items: center; */
    width: 75%;
    margin: auto;
    display: block; 

`

const Paragraph = styled.div`
    padding: 20px 0;
    @media (max-width: 700px){
    font-size: 15px;
    padding: 10px 0;
    }
`

const Credits = styled.div`
    font-family: ${fonts.credits};
    font-weight: 400;
    padding-left: 10px;
    font-size: 12px;
    text-align: center;
    padding-right: 10px;
    color: black;
`;

function CustomizedTab(props){
return(
    <Tabs defaultActiveKey="Artists" transition={false}>
        {props.data.map((content,index)=>{
            return(
                <Tab eventKey={content.tab_name} title={content.title}>
                    <TextBox>
                        <Title>{content.title}</Title>
                        {content.content.map(block=>{
                            if(block.type==="paragraph") {
                                return(<Paragraph>{block.content}</Paragraph>);
                            }
                            if(block.type==="image"){
                                return(
                                    <>
                                        <Image src={block.image_link}/>
                                        <Credits>{block.image_credits}</Credits>
                                    </>
                                )
                            }
                        })}
                    </TextBox>
                </Tab>
            )
        })}
    </Tabs>
);
}  


export default CustomizedTab;